import { FormattedMessage } from "react-intl";
import { Link } from "react-router";

export function DocumentDeleteConflictAlert({ sharedItemIds }: { sharedItemIds: readonly string[] }) {
  return (
    <div className="mt-3 text-[11px] text-red-600" role="alert">
      <FormattedMessage
        id="service.page.documentDeleteBlocked"
        defaultMessage="This document is still used in shared posts. Remove it there first:"
      />
      <ul className="mt-1 flex flex-wrap gap-x-3 gap-y-1">
        {sharedItemIds.map((sharedItemId, index) => (
          <li key={sharedItemId}>
            <Link
              className="font-medium underline underline-offset-2 hover:text-red-800"
              to={`/share/discover/${sharedItemId}`}
            >
              <FormattedMessage
                id="service.page.openBlockingSharedItem"
                defaultMessage="Open shared post {number}"
                values={{ number: index + 1 }}
              />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
